import clsx from 'clsx';
import { Box } from '@mui/material';
import { Logo, ProgressFlow } from '@care/react-component-lib';
import useFlowHelper from '@/components/hooks/useFlowHelper';
import { FlowType, SxClassProps } from '@/types/common';
import { YesOrNoAnswer } from '@/__generated__/globalTypes';
import { useSeekerState } from './AppState';
import useMVEnrollmentSteps from './hooks/useMVEnrollmentSteps';

const classes: SxClassProps = {
  wrapper: (theme) => ({
    '& .progress-flow-status': {
      borderBottom: 0,
    },
    '&.bottom-border': {
      borderBottom: `1px solid ${theme.palette.care?.grey[300]}`,
    },
  }),
};

const ProgressFlowNavbar = () => {
  const {
    stepNumber,
    totalSteps,
    currentFlow,
    hideStepNumber,
    hideProgressIndicator,
    showBottomBorder,
  } = useFlowHelper();
  const { isUserAssignedToSkipSteps } = useSeekerState();
  const { mvHideSteps, mvLabel, mvTotalSteps } = useMVEnrollmentSteps({ stepNumber });
  let label = '';

  let hideSteps = hideStepNumber || !currentFlow || isUserAssignedToSkipSteps === YesOrNoAnswer.YES;

  let totalStepsNumber = totalSteps;

  if (currentFlow === FlowType.PROVIDER_MV_DETAILS) {
    label = mvLabel;
    hideSteps = mvHideSteps;
    totalStepsNumber = mvTotalSteps;
  }

  if (currentFlow === FlowType.PROVIDER_MV_ACCOUNT_CREATION) {
    label = 'Create your account';
    totalStepsNumber = 3;
  }

  return (
    <Box sx={classes.wrapper} className={clsx(showBottomBorder && 'bottom-border')}>
      <ProgressFlow
        step={stepNumber}
        total={totalStepsNumber}
        label={label}
        hideSteps={hideSteps}
        hideProgress={hideProgressIndicator}
        logo={
          <Box component="div" tabIndex={0} role="button" data-testid="care-logo">
            <Logo />
          </Box>
        }
        link=""
      />
    </Box>
  );
};

ProgressFlowNavbar.defaultProps = {
  currentFlow: '',
};

export default ProgressFlowNavbar;
